"use strict";
var splideOptions = {
    perPage: 1,
    perMove: 1,
    type: 'slide',
    gap: "0rem",
    pagination: false,
    arrows: false,
    drag: false,
    speed: 0,
    waitForTransition: false,
};
function setupProductItems(items) {
    // Keep in line with single_product.ts
    if (items && items.length) {
        for (var index = 0; index < items.length; index++) {
            var productItem = items[index];
            if (productItem) {
                calculateProductItemSavingsBadgePercentage(productItem);
                calculateProductItemSavingsAmount(productItem);
                setupVariantSelectorListeners(productItem);
                initSplide(productItem);
            }
        }
    }
}
var productItems = document.querySelectorAll('.product');
setupProductItems(productItems);
function calculateProductItemSavingsBadgePercentage(productItem) {
    var savingsTag = productItem.querySelector('.badges .badge.savings-badge span');
    if (savingsTag) {
        var price = productItem.getAttribute('data-price') || "";
        var comparePrice = productItem.getAttribute('data-compare-price') || "";
        setSavingsBadge(savingsTag, price, comparePrice);
    }
}
function calculateProductItemSavingsAmount(productItem) {
    var comparePriceSpan = productItem.querySelector(".savings-amount span");
    var price = (parseInt(productItem.getAttribute('data-price') || "0") / 100).toString();
    var comparePrice = (parseInt(productItem.getAttribute('data-compare-price') || "") / 100).toString();
    if (comparePriceSpan && price && comparePrice) {
        setComparePriceSavingsAmount(comparePriceSpan, price, comparePrice);
    }
}
function setupVariantSelectorListeners(productItem) {
    var variants = productItem.querySelectorAll('.variants button');
    if (variants && variants.length) {
        variants.forEach(function (variant) {
            variant.addEventListener('click', function () {
                var _a, _b;
                variants.forEach(function (variant) {
                    variant.classList.remove('active');
                });
                variant.classList.add('active');
                var id = variant.getAttribute('id') || "";
                var price = variant.getAttribute("data-variant-price") || "";
                var comparePrice = variant.getAttribute("data-variant-compare-price") || "";
                var quantity = parseInt(variant.getAttribute("data-quantity") || "0");
                var trackedInv = variant.getAttribute("data-variant-inventory_management");
                var mediaId = variant.getAttribute("data-variant-media-id");
                var checkQuantity = trackedInv === "shopify";
                var savingsTag = productItem.querySelector('.badges .badge.savings-badge span');
                if (savingsTag) {
                    setSavingsBadge(savingsTag, price, comparePrice);
                }
                var comparePriceSpan = productItem.querySelector(".savings-amount span");
                if (comparePriceSpan) {
                    setComparePriceSavingsAmount(comparePriceSpan, price, comparePrice);
                }
                var productItemButton = productItem.querySelector('.button-wrapper button');
                if (productItemButton) {
                    var allVariantsSoldOut = productItem.getAttribute('data-all-variants-sold-out') === 'true';
                    if (allVariantsSoldOut) {
                        productItemButton.setAttribute('data-variant-id', id);
                    }
                    else if (checkQuantity && quantity == 0) {
                        productItemButton.querySelector("span").textContent = "Sold out";
                    }
                    else {
                        productItemButton.querySelector("span").textContent = "Add to Cart";
                    }
                    if (!allVariantsSoldOut) {
                        productItemButton.setAttribute('data-id', id);
                    }
                    var productItemPrice = productItem.querySelector('.price');
                    var newPriceContent = "".concat(price, " ").concat((comparePrice) ? "<span>".concat(comparePrice, "</span>") : "");
                    productItemPrice.innerHTML = newPriceContent;
                }
                if (mediaId) {
                    var mediaImage = productItem.querySelector('.images-wrapper .image-wrapper[data-media-id="' + mediaId + '"]');
                    if (mediaImage) {
                        var slideIndex = parseInt(mediaImage.getAttribute('data-index') || "0");
                        var splideElement = productItem.querySelector('.product-item-thumbnails-splide');
                        // @ts-ignore
                        var splide = new Splide(splideElement, splideOptions).mount();
                        splide.go(slideIndex - 1);
                    }
                }
                var priceInt = parseRandToCents(price);
                if ((priceInt) >= 80000) {
                    (_a = productItem.querySelector(".badges .free-ship")) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
                }
                else {
                    (_b = productItem.querySelector(".badges .free-ship")) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
                }
            });
        });
    }
}
function initSplide(productItem) {
    var splide = productItem.querySelector('.product-item-thumbnails-splide');
    if (splide) {
        // @ts-ignore
        new Splide(splide, splideOptions).mount();
    }
}
